// @ts-ignore
import * as vtk from '../lib/vtk.js';

export abstract class VtkStlReader {
  static polyData = null;
  static isLoading = false;

  public static loadPolyDataFromFile(file: File, div: string) {
    this.isLoading = true;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onloadend = () => {
      if (fileReader.result !== null) {
        this.loadPolyDataFromArrayBuffer(fileReader.result, div);
      }
    };
  }

  private static async loadPolyDataFromArrayBuffer(arrayBuffer: ArrayBuffer | string, renderDiv: string) {
    if (this.polyData) {
      const div = document.getElementById(renderDiv);
      if (div) {
        while (div.childNodes.length > 0) {
          if (div.firstChild !== null) {
            div.removeChild(div.firstChild);
          }
        }
      }
    }

    const reader = vtk.IO.Geometry.vtkSTLReader.newInstance();

    reader.parseAsArrayBuffer(arrayBuffer);
    this.polyData = reader.getOutputData();

    const mapper = vtk.Rendering.Core.vtkMapper.newInstance({
      scalarVisibility: false,
    });
    const actor = vtk.Rendering.Core.vtkActor.newInstance();
    const renderer = this.initRenderer(renderDiv);

    const renderWindow = renderer.getRenderWindow();
    if (renderer) {
      // Stop listening to keydown events
      const interactorStyle = renderWindow.getInteractor().getInteractorStyle();
      interactorStyle.get('subscribedEvents').subscribedEvents[3].unsubscribe();

      actor.setMapper(mapper);
      mapper.setInputData(this.polyData);
      actor.getProperty().setColor(0.44, 0.636, 0.828);
      renderer.addActor(actor);
    }

    renderer.resetCamera(actor.getBounds());
    renderWindow.render();

    this.isLoading = false;
  }

  private static initRenderer(renderDiv: string): any {
    try {
      const container = document.getElementById(renderDiv);

      const fullScreenRenderer = vtk.Rendering.Misc.vtkFullScreenRenderWindow.newInstance({
        background: [1, 1, 1],
        rootContainer: container,
        containerStyle: { height: '100%', width: '100%' },
      });
      const renderer = fullScreenRenderer.getRenderer();
      // renderer.removeAllLights();
      // return this.addLights(renderer);
      return renderer;
    } catch {
      /**
       * Random error that occurs in chrome every once in a while, see
       * https://github.com/Kitware/vtk-js/issues/472
       */
      console.warn('Could not create WebGL context, please close the tab/window and navigate to the website again');
      return false;
    }
  }
}
